"use client";

import type { PropsWithChildren } from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LazyMotion } from "motion/react";
import { useEffect, useState } from "react";

import { useDomEventDataTracker } from "@trex-2b/hooks";
import { initGA } from "@trex-2b/libs";
import { initializeTrexAuth } from "@trex-2b/libs/config";
import { ToastViewport } from "@trex-2b/ui";
import { BugsnagErrorBoundary } from "@trex-2b/ui/bugsnag-error-boundary";

const loadFeatures = () => import("motion/react").then((mod) => mod.domMax);

export default function TrexWebClientProviders({
  children,
}: PropsWithChildren) {
  const [queryClient] = useState(() => new QueryClient());
  useDomEventDataTracker();
  useEffect(() => {
    initializeTrexAuth();
    initGA({ sourcePlatform: "onboarding" });
  }, []);

  return (
    <BugsnagErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <LazyMotion features={loadFeatures} strict>
          {children}
          <ToastViewport />
        </LazyMotion>
      </QueryClientProvider>
    </BugsnagErrorBoundary>
  );
}
